module.exports = __webpack_public_path__ + "static/media/image_Male.639d58b4.svg";